"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XferInput = /** @class */ (function () {
    function XferInput(accountId, authDescriptorId, assetId, amount) {
        this.accountId = accountId;
        this.authDescriptorId = authDescriptorId;
        this.assetId = assetId;
        this.amount = amount;
    }
    XferInput.prototype.toGTV = function () {
        return [
            this.accountId,
            this.assetId,
            this.authDescriptorId,
            this.amount,
            []
        ].toGTV();
    };
    return XferInput;
}());
exports.XferInput = XferInput;
function xferInput(accountId, authDescriptorId, assetId, amount) {
    return new XferInput(accountId, authDescriptorId, assetId, amount);
}
exports.xferInput = xferInput;
var XferOutput = /** @class */ (function () {
    function XferOutput(accountId, assetId, amount) {
        this.accountId = accountId;
        this.assetId = assetId;
        this.amount = amount;
    }
    XferOutput.prototype.toGTV = function () {
        return [
            this.accountId,
            this.assetId,
            this.amount,
            []
        ].toGTV();
    };
    return XferOutput;
}());
exports.XferOutput = XferOutput;
function xferOutput(accountId, assetId, amount) {
    return new XferOutput(accountId, assetId, amount);
}
exports.xferOutput = xferOutput;
var SimpleTransfer = /** @class */ (function () {
    function SimpleTransfer(sourceAccountId, destinationAccountId, authDescriptorId, assetId, amount) {
        this.sourceAccountId = sourceAccountId;
        this.destinationAccountId = destinationAccountId;
        this.authDescriptorId = authDescriptorId;
        this.assetId = assetId;
        this.amount = amount;
    }
    SimpleTransfer.prototype.toGTV = function () {
        return [
            "simple_transfer",
            xferInput(this.sourceAccountId, this.authDescriptorId, this.assetId, this.amount),
            xferOutput(this.destinationAccountId, this.assetId, this.amount)
        ].toGTV();
    };
    return SimpleTransfer;
}());
exports.SimpleTransfer = SimpleTransfer;
function simpleTransfer(sourceAccountId, destinationAccountId, authDescriptorId, assetId, amount) {
    return new SimpleTransfer(sourceAccountId, destinationAccountId, authDescriptorId, assetId, amount);
}
exports.simpleTransfer = simpleTransfer;
var Transfer = /** @class */ (function () {
    function Transfer(inputs, outputs) {
        this.inputs = inputs;
        this.outputs = outputs;
    }
    Transfer.prototype.toGTV = function () {
        return ["transfer", this.inputs, this.outputs].toGTV();
    };
    return Transfer;
}());
exports.Transfer = Transfer;
//# sourceMappingURL=transfer.js.map